'use client';

import { useField } from 'formik';
import { FC } from 'react';

import { InputFormikProps } from './Input.type';
import { InputMasked } from './InputMasked';

/**
 * Input field expected to be used within a Formik context
 */
export const InputMaskedFormik: FC<InputFormikProps<typeof InputMasked>> = (props) => {
  const [field, meta, helpers] = useField(props.name);

  return (
    <InputMasked
      {...props}
      value={field.value}
      error={meta.error && meta.touched ? meta.error : undefined}
      onChange={(value) => {
        console.log('value', value);
        helpers.setValue(value);
      }}
      onBlur={field.onBlur}
      data-testid={props['data-testid']}
    />
  );
};
